<template>
	<div v-show="pre_show">
		<label class="pre-inline">{{pre_item.name}}:</label>

		<el-input type="textarea" autosize :class="[pre_item.class==''?'short0':pre_item.class]" class="pre-textarea"
			:placeholder="pre_item.note" v-model="pre_item.val" :readonly="(pre_item.r=='1') ? 'readonly':false "
			:rows="20" @change="val_back" @focus="fun_once" >
		</el-input>
		<em v-show="pre_item.w=='1'">*</em><em v-show="pre_item.w=='0'"></em>
	</div>
</template>

<script>
	//

	import {
		BackSpecial
	} from "@/utils/localstore.js";

	export default {
		name: "hj-textarea",
		data() {
			return {
				pre_item: {},
				pre_show: true
			}
		},
		props: {
			inData: {
				type: String,
				default: ''
			}
		},
		watch: {
			inData(val) {
				// console.log('hj-datemonth 检测', val);
				let temp = '';
				temp = JSON.parse(this.inData).val;
				temp = BackSpecial(temp);
				temp = temp.replace(/<br\/>/g, '\n').replace(/\&nbsp\;/g, ' ');
				temp = temp.replace(/<br>/g, '\n');

				this.pre_item = {};
				this.pre_item = JSON.parse(this.inData);
				this.pre_item.val = temp;

				this.check_data();
			}
		},
		created() {
			this.pre_item = {};
			this.pre_item = JSON.parse(this.inData);
			// console.log(this.pre_item);
			this.check_data();

		},
		// mounted: function() {
		//   console.log('hj-datemonth 组件 mounted');
		//   if (typeof(this.inData) !== 'undefined' && this.inData != '') {
		//     let temp = '';
		//     temp = JSON.parse(this.inData).val;
		//     temp = temp.replace(/<br\/>/g, '\n').replace(/\&nbsp\;/g, ' ');
		//     temp = temp.replace('<br>', '\n');
		//     console.log(temp);

		//     this.pre_item = {};
		//     this.pre_item = JSON.parse(this.inData);
		//   }
		// },
		activated: function() {
			console.log('keep-alive 组件激活时调用 hj-textarea激活');
			// console.log(this.inData);
			this.pre_item = {};
			this.pre_item = JSON.parse(this.inData);
			this.check_data();
		},
		deactivated: function() {
			console.log('keep-alive 组件激活时调用 hj-textarea停用');
			this.pre_item = {};
		},
		methods: {
			check_data: function() {
				let temp = '';
				temp = this.pre_item.val;
				// console.log(temp);
				// if (typeof(temp) === 'undefined' || temp == '') {
				// 	this.pre_show = false;
				// } else {
				// 	this.pre_show = true;
				// }
			},
			val_back: function() {
				// let temp_val = ''
				// temp_val = this.pre_item.val;
				// temp_val = temp_val.replace(/\n/g, '<br/>');
				// temp_val = temp_val.replace(/\s/g, '&nbsp;');
				// this.pre_item.val = temp_val;
				this.$emit('com-event', this.pre_item);
			},
			fun_once: function() {
				this.$emit('com-event', this.pre_item, 'click');
			}
		}
	}
</script>

<style scoped="scoped">
	.pre-inline {
		display: inline-block;
		vertical-align: top;
		margin-right: 2px;
		min-width: 108px;
	}

	.pre-textarea {
		font-weight: bold;

	}
</style>